"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAddress = addAddress;
exports.apiCreateFinanceAddress = apiCreateFinanceAddress;
exports.apiDelAddress = apiDelAddress;
exports.apiDelFinanceAddress = apiDelFinanceAddress;
exports.apiFetchOtcUrl = apiFetchOtcUrl;
exports.apiGetFinanceAddressList = apiGetFinanceAddressList;
exports.apiGetUserInfoByAddress = apiGetUserInfoByAddress;
exports.apiGetUserItems = apiGetUserItems;
exports.apiSaveFinanceAddress = apiSaveFinanceAddress;
exports.apiWyreUrl = apiWyreUrl;
exports.bindEmailCode = bindEmailCode;
exports.bindMobileCode = bindMobileCode;
exports.changeEmailCode = changeEmailCode;
exports.changeMobileCode = changeMobileCode;
exports.getAddress = getAddress;
exports.getAddressList = getAddressList;
exports.getAssetsList = getAssetsList;
exports.getCoinList = getCoinList;
exports.getExchangeListV2 = getExchangeListV2;
exports.getINCoinExchangeListV2 = getINCoinExchangeListV2;
exports.getStaticCoinList = getStaticCoinList;
exports.getUserExchangeLimit = getUserExchangeLimit;
exports.sendEmailCode = sendEmailCode;
exports.sendSmsCode = sendSmsCode;
exports.transfer = transfer;
exports.transferEmailCode = transferEmailCode;
exports.transferMobileCode = transferMobileCode;
exports.verifyEmailCode = verifyEmailCode;
exports.verifyMobileCode = verifyMobileCode;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.json.stringify.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _api = _interopRequireDefault(require("@/assets/js/api"));

var _stationSetting = require("@/assets/js/stationSetting");

// const { VUE_APP_UCENTER } = process.env;
//缓存CoinList,防止多次请求
function getStaticCoinList() {
  return _getStaticCoinList.apply(this, arguments);
}

function _getStaticCoinList() {
  _getStaticCoinList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var result, lastTime, nowTime, coinListInfo, _timestamp, _yield$getCoinList, status, data, timestamp;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            //先查缓存
            result = localStorage.getItem("coinListInfo");
            lastTime = localStorage.getItem("coinListLastTime");
            nowTime = Date.parse(new Date()) / 1000;

            if (!(result && result != "undefined" && result != "{}" && result != "[object Object]" && nowTime - lastTime > 1 * 60)) {
              _context.next = 9;
              break;
            }

            _timestamp = Date.parse(new Date()) / 1000;
            localStorage.setItem("coinListLastTime", _timestamp);
            console.log("更新CoinList");
            _context.next = 12;
            break;

          case 9:
            if (!(result && result != "undefined" && result != "{}" && result != "[object Object]")) {
              _context.next = 12;
              break;
            }

            coinListInfo = JSON.parse(result);
            return _context.abrupt("return", {
              status: 200,
              data: coinListInfo
            });

          case 12:
            _context.next = 14;
            return getCoinList();

          case 14:
            _yield$getCoinList = _context.sent;
            status = _yield$getCoinList.status;
            data = _yield$getCoinList.data;

            if (data) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("return", {});

          case 19:
            coinListInfo = data;
            localStorage.setItem("coinListInfo", JSON.stringify(coinListInfo));
            timestamp = Date.parse(new Date()) / 1000;
            localStorage.setItem("coinListLastTime", timestamp);
            return _context.abrupt("return", {
              status: 200,
              data: coinListInfo
            });

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getStaticCoinList.apply(this, arguments);
}

function getCoinList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/Settings/itemList",
    data: data,
    type: "POST"
  });
}

function apiGetUserItems() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/User/userItems",
    data: data,
    type: "POST"
  });
}

function getAssetsList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Assets/getAssetsList",
    data: data,
    type: "POST"
  });
}

function getExchangeListV2() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Assets/getCoinExchangeListV2",
    data: data,
    type: "POST"
  });
}

function getINCoinExchangeListV2() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Assets/getCoinExchangeListV2",
    data: data,
    type: "POST"
  });
}

function getUserExchangeLimit() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Users/getUserExchangeLimit",
    data: data,
    type: "POST"
  });
} //获取充币地址


function getAddress() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Address/getAddress",
    data: data,
    type: "POST"
  });
} //获取财务充币地址列表


function apiGetFinanceAddressList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Address/getFinanceAddressList",
    data: data,
    type: "POST"
  });
} //三方支付wyre地址


function apiWyreUrl() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_APP + "/OtcPay/wyre",
    data: data,
    type: "POST"
  });
} //三方支付快捷买币地址


function apiFetchOtcUrl() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_APP + "/ThirdPayment/fetchOtcUrl",
    data: data,
    type: "POST"
  });
} //获取财务充币地址列表


function apiCreateFinanceAddress() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Address/createFinanceAddress",
    data: data,
    type: "POST"
  });
} //获取财务充币地址列表


function apiSaveFinanceAddress() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Address/saveFinanceAddress",
    data: data,
    type: "POST"
  });
} //获取财务充币地址列表


function apiDelFinanceAddress() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Address/delFinanceAddress",
    data: data,
    type: "POST"
  });
} //获取财务充币地址列表


function sendEmailCode() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Users/sendEmailCode",
    data: data,
    type: "POST"
  });
}

function sendSmsCode() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Users/sendSmsCode",
    data: data,
    type: "POST"
  });
} //发送绑定短信


function bindMobileCode() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/V3/UCenter/User/bindMobileCode",
    data: data,
    type: "POST"
  });
} //发送换绑短信


function changeMobileCode() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/V3/UCenter/User/changeMobileCode",
    data: data,
    type: "POST"
  });
} //发送安全项变更短信


function verifyMobileCode() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/V3/UCenter/User/verifyMobileCode",
    data: data,
    type: "POST"
  });
} //发送提币转账短信


function transferMobileCode() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/V3/UCenter/User/transferMobileCode",
    data: data,
    type: "POST"
  });
} //发送绑定邮件


function bindEmailCode() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/V3/UCenter/User/bindEmailCode",
    data: data,
    type: "POST"
  });
} //发送换绑邮件


function changeEmailCode() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/V3/UCenter/User/changeEmailCode",
    data: data,
    type: "POST"
  });
} //发送安全项变更邮件


function verifyEmailCode() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/V3/UCenter/User/verifyEmailCode",
    data: data,
    type: "POST"
  });
} //发送提币转账邮件


function transferEmailCode() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/V3/UCenter/User/transferEmailCode",
    data: data,
    type: "POST"
  });
}

function getAddressList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Address/addressList",
    data: data,
    type: "POST"
  });
}

function addAddress() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Address/addAddress",
    data: data,
    type: "POST"
  });
} // 二次验证,提币借口


function transfer() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Assets/transfer",
    data: data,
    type: "POST"
  });
} //判断地址是否为内部地址


function apiGetUserInfoByAddress() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Address/getUserInfoByAddress",
    data: data,
    type: "POST"
  });
} //删除提币地址


function apiDelAddress() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: _stationSetting.VUE_APP_UCENTER + "/UCenter/Address/delAddress",
    data: data,
    type: "POST"
  });
}